import { useMemo } from "react"
import { useTranslation } from "react-i18next"

import { useProductPageAddonTitlesContext } from "../context/ProductPageAddonTitlesContext"
import { useProductPageContext } from "../context/ProductPageContext"
import { useProductPageImportContext } from "../context/ProductPageImportContext"

export function useProductPageNavigationAnchors() {
  const { variantKey, productData } = useProductPageContext()
  const { titleByProductType } = useProductPageAddonTitlesContext()
  const { hasQuickInfos, hasDownloads, hasReferences } =
    useProductPageImportContext()
  const { t } = useTranslation()
  const productInformation = productData.productInformation?.data
  const addons = productInformation?.addons

  return useMemo(
    () =>
      addons && addons.length > 0
        ? [
            {
              key: "main",
              href: `#product-main`,
              label: productInformation?.title || variantKey
            },
            ...addons.map((addon, index) => ({
              key: `addon-${index + 1}`,
              href: `#addon-${index + 1}-information`,
              label: titleByProductType[addon.productType] || addon.title
            }))
          ]
        : [
            {
              key: "summary",
              href: `#product-summary`,
              label: t("ProductPage.YourProduct")
            },
            ...(hasQuickInfos
              ? [
                  {
                    key: "information",
                    href: `#product-information`,
                    label: t("Product.Information.GeneralProductInformation")
                  }
                ]
              : []),
            ...(hasDownloads
              ? [
                  {
                    key: "downloads",
                    href: `#product-downloads`,
                    label: t("Product.Information.Downloads")
                  }
                ]
              : []),
            ...(productInformation?.generalDescription ||
            productInformation?.variantDescription
              ? [
                  {
                    key: "tender-text",
                    href: `#product-tender-text`,
                    label: t("Product.TenderTexts")
                  }
                ]
              : []),
            ...(productInformation?.attributes
              ? [
                  {
                    key: "attributes",
                    href: `#product-attributes`,
                    label: t("Product.Information.ConfigurationAttributes")
                  }
                ]
              : []),
            ...(productInformation?.dimensioning
              ? [
                  {
                    key: "external-dimensioning",
                    href: `#product-external-dimensioning`,
                    label: t("Product.Configuration.Dimensioning")
                  }
                ]
              : []),
            ...(hasReferences
              ? [
                  {
                    key: "references",
                    href: `#product-building-references`,
                    label: t("Product.References")
                  }
                ]
              : [])
          ],
    [
      addons,
      titleByProductType,
      productInformation,
      variantKey,
      t,
      hasQuickInfos,
      hasDownloads,
      hasReferences
    ]
  )
}
